import React from 'react';

import styles from './index.module.css';

interface Props {
  content: string;
}
export const CustomContent: React.FC<Props> = ({ content }) => (
  <div className={styles.CustomContent}>
    <div
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  </div>
);
